export const CUSTOM_PAGE_SECTION_IDS = {
	PARAGRAPH_SECTION: "Paragraph Section",
};
